import { readable_reward } from "../../generated/models/readable_reward";
import isOfferExpired from "./isOfferExpired";

/**
 * Filters basket items to include only non-expired offers.
 * Removes:
 * - Items without offers
 * - Expired offers
 *
 * @param basketItems - Array of basket items to filter
 * @returns Filtered array of non-expired basket items
 */
export default function filterNonExpiredBasketItems(
  basketItems: readonly readable_reward[],
  now: Date,
): readable_reward[] {
  return basketItems.filter((r) => {
    if (!r.offer) return false;

    const endDate = r.offer.ended_at ? new Date(r.offer.ended_at) : now;

    return !isOfferExpired(endDate, now);
  });
}
